import React from 'react';
import PropTypes from 'prop-types';

// Overrides
import {
  AccountSetupOverride,
  DetailListOverride,
  FamilyMemberDetailOverride,
  OnboardingWelcomeOverride,
  PersonalInformationOverride,
  QualitativeQuestionOverride,
} from 'Overrides/OnboardingStep';
import IncomeWelcomeSectionOverride
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/IncomeWelcome/MetaOverride';
import DefaultLayoutOverride from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/Default/MetaOverride';
import CompleteMemberConciergeOverride
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/CompleteMemberConciergeChoosePath/MetaOverrideSet';
import { IncomeSalaryOverride } from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/IncomeSalary/MetaOverride';

// Layouts
import BaseOverride from 'Overrides/OnboardingStep/BaseOverride';
import VerifyTwoFactorCodeOverride from 'Overrides/OnboardingStep/VerifyTwoFactorCode';
import RiskToleranceWelcomeLayout
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/RiskTolerance/RiskToleranceWelcomeLayout';
import RiskToleranceResultLayout
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/RiskTolerance/RiskToleranceResultLayout';
import RiskToleranceManualLayout
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/RiskTolerance/RiskToleranceManualLayout';
import DocumentUploadWelcomeLayout
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/DocumentUploadWelcome/DocumentUploadWelcomeLayout';
import EmbeddedWizardLayout from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/EmbeddedWizard/Layout';
import IncomeStepOverride from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/IncomeStep/MetaOverride';
import CompleteMemberConciergeMeetingConfirmationLayout
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/CompleteMemberConciergeMeetingConfirmation/Layout';
import CompleteMemberConciergeChoosePathLayout
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/CompleteMemberConciergeChoosePath/Layout';
import CompleteMemberConciergeScheduleMeetingLayout
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/CompleteMemberConciergeScheduleMeeting/Layout';
import WelcomeInfoLayoutDefault
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/WelcomeRework/WelcomeInfoLayoutDefault';
import WelcomeInfoLayoutWithBottomImage
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/WelcomeRework/WelcomeInfoLayoutWithBottomImage';
import {
  IncomeSalaryLayout,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/IncomeSalary/IncomeSalaryLayout';
import {
  IncomeSalaryPayStubUploadLayout,
  IncomeSalaryPayStubUploadOverride,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/IncomeSalaryPayStubUpload';
import {
  IncomeSalaryPayStubDetailsLayout,
  IncomeSalaryPayStubDetailsOverride,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/IncomeSalaryPayStubDetails';
import {
  ChooseIncomeCategoriesLayout,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/ChooseIncomeCategories/ChooseIncomeCategoriesLayout';
import ChooseIncomeCategoriesOverride from 'Overrides/OnboardingStep/ChooseIncomeCategoriesOverride';
import {
  IncomeInformationOverride,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/IncomeInformation/IncomeInformationMetaOverride';
import {
  IncomeInformationOnboardingLayout,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/IncomeInformation/IncomeInformationOnboardingLayout';
import {
  IncomeAttestationLayout,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/IncomeAttestation/IncomeAttestationLayout';
import {
  IncomeAttestationOverride,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/IncomeAttestation/IncomeAttestationMetaOverride';
import OnboardingMoneyPsychQuestionLayout
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingMoneyPsychQuestionLayout/Layout';
import OnboardingSelectRecurringExpenses
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingSelectRecurringExpenses/Layout';
import OnboardingRecurringExpenses
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingRecurringExpenses/Layout';
import OnboardingOneTimeExpenses
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingOneTimeExpenses/Layout';
import OnboardingExpenseSummary
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingExpenseSummary/Layout';
import {
  AssetsAndLiabilitiesPartnerQuestionMetaOverride,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/AssetsAndLiabilitiesPartnerQuestion/metaOverride';
import ModuleWelcomeLayout from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/ModuleWelcome/Layout';
import GoalSelectionLayout from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalSelection/Layout';
import GoalSelectionOverride from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalSelection/MetaOverride';
import OnboardingAssetsAndLiabilitiesOverallChecklist
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingAssetsAndLiabilitiesOverallChecklist/Layout';
import {
  SaveForRetirementOverride,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/SaveForRetirement/MetaOverride';
import {
  SaveForRetirementLayout,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/SaveForRetirement/Layout';
import { GoalDetailLayout } from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalDetail/GoalDetailLayout';
import { GoalDetailOverride } from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalDetail/MetaOverride';
import { PayOffDebtLayout } from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/PayOffDebt/Layout';
import {
  OnboardingAssetsAndLiabilitiesAddLayout,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingAssetsAndLiabilitiesAdd/Layout';
import {
  OnboardingAssetsAndLiabilitiesSummaryLayout,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingAssetsAndLiabilitiesSummary/Layout';
import { GoalSummaryOverride } from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalSummary/MetaOverride';
import { GoalPrioritizationLayout } from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalPrioritization/GoalPrioritizationLayout';
import { GoalPrioritizationOverride } from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalPrioritization/MetaOverride';
import { PayOffDebtOverride } from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/PayOffDebt/MetaOverride';
import {
  OnboardingGoalSummary,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalSummary/OnboardingGoalSummary';
import {
  OnboardingClientDashboardRedirect,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingClientDashboardRedirect/Layout';
import OnboardingPostOnboardingFirstWin
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingPostOnboardingFirstWin/Layout';
import OnboardingPostOnboardingWhatIsNext
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingPostOnboardingWhatIsNext/Layout';
import OnboardingPlannerAssignmentFinalizingMatch
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingPlannerAssignmentFinalizingMatch/Layout';
import OnboardingPlannerAssignmentSelectPlanner
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingPlannerAssignmentSelectPlanner/Layout';
import OnboardingPlannerAssignmentRecommendedPlanner
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingPlannerAssignmentRecommendedPlanner/Layout';
import OnboardingPostOnboardingScheduleFirstMeeting
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingPostOnboardingScheduleFirstMeeting/Layout';
import OnboardingPostOnboardingFirstMeetingConfirmation
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingPostOnboardingFirstMeetingConfirmation/Layout';
import DocumentUploadLayout from './StepLibrary/DocumentUpload/Layout';
import DocumentUploadOverride from './StepLibrary/DocumentUpload/MetaOverride';
import FamilyMemberDetailLayout from './StepLibrary/FamilyMemberDetail/Layout';
import IncomeWelcomeLayout from './StepLibrary/IncomeWelcome/Layout';
import QualitativeQuestionLayout from './StepLibrary/QualitativeQuestion/Layout';
import DetailListLayout from './StepLibrary/DetailList/Layout';
import DefaultLayout from './StepLibrary/Default/Layout';
import OnboardingScheduleMeetingLayout from './StepLibrary/OnboardingScheduleMeeting/Layout';
import OnboardingCompletedLayout from './StepLibrary/CompletedOnboarding/Layout';
import PersonalInformationLayout from './StepLibrary/PersonalInformation/Layout';
import BalanceSheetWelcomeLayout from './StepLibrary/BalanceSheetWelcome/Layout';
import InsightsLayout from './StepLibrary/Insights/Layout';
import ExpensesWelcomeLayout from './StepLibrary/ExpensesWelcome/Layout';
import OnboardingWelcomeLayout from './StepLibrary/OnboardingWelcome/Layout';
import AssetsAndLiabilitiesPartnerQuestionLayout from './StepLibrary/AssetsAndLiabilitiesPartnerQuestion/Layout';

// Account Setup layouts
import AccountSetupCreatePasswordLayout from './StepLibrary/AccountSetupCreatePassword/Layout';
import AccountSetupPasswordSavedLayout from './StepLibrary/AccountSetupPasswordSaved/Layout';
import AccountSetupTwoFactorAuthenticationLayout from './StepLibrary/AccountSetupTwoFactorAuthentication/Layout';
import AccountSetupTwoFactorAuthenticationPhoneNumberLayout
  from './StepLibrary/AccountSetupTwoFactorAuthenticationPhoneNumber/Layout';
import AccountSetupTwoFactorAuthenticationVerificationLayout
  from './StepLibrary/AccountSetupTwoFactorAuthenticationVerification/Layout';
import AccountSetupTwoFactorEnabledSuccessLayout from './StepLibrary/AccountSetupTwoFactorEnabledSuccess/Layout';
import AccountSetupRememberThisDeviceLayout from './StepLibrary/AccountSetupRememberThisDevice/Layout';
import AccountSetupSuccessLayout from './StepLibrary/AccountSetupSuccess/Layout';

import SurveyStepForm from './SurveyStepForm';

const SURVEY_LAYOUTS = {
  onboardingWelcome: 'onboardingWelcome',
  onboardingEmbeddedWizard: 'onboardingEmbeddedWizard',
  onboardingPersonalInformation: 'onboardingPersonalInformation',
  onboardingQualitativeQuestion: 'onboardingQualitativeQuestion',
  onboardingChooseIncomeCategories: 'onboardingChooseIncomeCategories',
  DetailList: 'DetailList',
  onboardingFamilyMemberDetail: 'onboardingFamilyMemberDetail',
  onboardingIncomeSectionWelcome: 'onboardingIncomeSectionWelcome',
  OnboardingIncomeInformation: 'OnboardingIncomeInformation',
  OnboardingIncomeAttestationStep: 'OnboardingIncomeAttestationStep',
  onboardingCompleted: 'onboardingCompleted',
  onboardingScheduleMeeting: 'onboardingScheduleMeeting',
  onboardingInsight: 'onboardingInsight',
  onboardingCompleteMemberConciergeChoosePath: 'onboardingCompleteMemberConciergeChoosePath',
  onboardingCompleteMemberConciergeScheduleMeeting: 'onboardingCompleteMemberConciergeScheduleMeeting',
  onboardingCompleteMemberConciergeMeetingConfirmation: 'onboardingCompleteMemberConciergeMeetingConfirmation',
  onboardingCompleteMemberConciergeMeetingConfirmationMoved: 'onboardingCompleteMemberConciergeMeetingConfirmationMoved',
  onboardingExpensesWelcome: 'onboardingExpensesWelcome',
  onboardingSetPassword: 'onboardingSetPassword',
  onboardingPasswordSaved: 'onboardingPasswordSaved',
  onboardingSelectRecurringExpenses: 'onboardingSelectRecurringExpenses',
  onboardingOneTimeExpenses: 'onboardingOneTimeExpenses',
  onboardingRecurringExpenseFrequencies: 'onboardingRecurringExpenseFrequencies',
  onboardingExpenseSummary: 'onboardingExpenseSummary',
  onboardingRecurringExpenseAmounts: 'onboardingRecurringExpenseAmounts',
  onboardingSetTwoFactorPhoneNumber: 'onboardingSetTwoFactorPhoneNumber',
  onboardingShouldEnableTwoFactor: 'onboardingShouldEnableTwoFactor',
  onboardingShouldRememberThisDevice: 'onboardingShouldRememberThisDevice',
  onboardingTwoFactorEnabledSuccess: 'onboardingTwoFactorEnabledSuccess',
  onboardingVerifyTwoFactorCode: 'onboardingVerifyTwoFactorCode',
  onboardingAuthFlowSuccess: 'onboardingAuthFlowSuccess',
  onboardingRiskToleranceWelcome: 'onboardingRiskToleranceWelcome',
  riskToleranceQuestionThinkingAboutInvesting: 'riskToleranceQuestionThinkingAboutInvesting',
  riskToleranceQuestionInvestingExperience: 'riskToleranceQuestionInvestingExperience',
  riskToleranceQuestionInvestingHistory: 'riskToleranceQuestionInvestingHistory',
  riskToleranceQuestionInvestingScenario: 'riskToleranceQuestionInvestingScenario',
  riskToleranceQuestionWithdrawal: 'riskToleranceQuestionWithdrawal',
  riskToleranceQuestionInvestingExperienceV2: 'riskToleranceQuestionInvestingExperienceV2',
  riskToleranceQuestionInvestmentKnowledge: 'riskToleranceQuestionInvestmentKnowledge',
  riskToleranceQuestionHowIFeelAboutInvesting: 'riskToleranceQuestionHowIFeelAboutInvesting',
  riskToleranceQuestionLongTermInvestmentPhilosophy: 'riskToleranceQuestionLongTermInvestmentPhilosophy',
  riskToleranceQuestionSignificantInvestmentLossReaction: 'riskToleranceQuestionSignificantInvestmentLossReaction',
  riskToleranceQuestionBiggestFinancialConcern: 'riskToleranceQuestionBiggestFinancialConcern',
  riskToleranceQuestion: 'riskToleranceQuestion',
  riskToleranceResult: 'riskToleranceResult',
  riskToleranceManual: 'riskToleranceManual',
  onboardingIncomeSalary: 'onboardingIncomeSalary',
  OnboardingIncomeSalaryPayStubUpload: 'onboardingIncomeSalaryPayStubUpload',
  OnboardingIncomeSalaryPayStubDetails: 'onboardingIncomeSalaryPayStubDetails',
  onboardingIncomeBonus: 'onboardingIncomeBonus',
  onboardingIncomeSelfEmployed: 'onboardingIncomeSelfEmployed',
  onboardingIncomeRental: 'onboardingIncomeRental',
  onboardingIncomeSocialSecurity: 'onboardingIncomeSocialSecurity',
  onboardingIncomeInvestment: 'onboardingIncomeInvestment',
  onboardingIncomeTrust: 'onboardingIncomeTrust',
  onboardingIncomeAnnuity: 'onboardingIncomeAnnuity',
  onboardingIncomePension: 'onboardingIncomePension',
  onboardingIncomeOther: 'onboardingIncomeOther',
  onboardingWelcomeIntro: 'onboardingWelcomeIntro',
  onboardingWelcomeWhatToExpect: 'onboardingWelcomeWhatToExpect',
  onboardingWelcomeHowToGetHelp: 'onboardingWelcomeHowToGetHelp',
  onboardingWelcomeThanksForSharing: 'onboardingWelcomeThanksForSharing',
  onboardingMoneyPsychQuestionMoneyAsATool: 'onboardingMoneyPsychQuestionMoneyAsATool',
  onboardingMoneyPsychQuestionInheritedBeliefs: 'onboardingMoneyPsychQuestionInheritedBeliefs',
  onboardingMoneyPsychQuestionApproachAsCouple: 'onboardingMoneyPsychQuestionApproachAsCouple',
  onboardingMoneyPsychQuestionCurrentApproach: 'onboardingMoneyPsychQuestionCurrentApproach',
  onboardingMoneyPsychQuestionDailyInstinct: 'onboardingMoneyPsychQuestionDailyInstinct',
  onboardingMoneyPsychQuestionSelfEfficacy: 'onboardingMoneyPsychQuestionSelfEfficacy',
  onboardingMoneyPsychQuestionEmotionalStartingPoint: 'onboardingMoneyPsychQuestionEmotionalStartingPoint',
  onboardingAssetsAndLiabilitiesAdd: 'onboardingAssetsAndLiabilitiesAdd',
  onboardingAssetsAndLiabilitiesSummary: 'onboardingAssetsAndLiabilitiesSummary',
  onboardingDocumentUpload: 'onboardingDocumentUpload',
  onboardingDocumentUploadWelcome: 'onboardingDocumentUploadWelcome',
  onboardingAssetsAndLiabilitiesOverallChecklist: 'onboardingAssetsAndLiabilitiesOverallChecklist',
  onboardingAssetsAndLiabilitiesWelcome: 'onboardingAssetsAndLiabilitiesWelcome',
  onboardingAssetsAndLiabilitiesPartnerQuestion: 'onboardingAssetsAndLiabilitiesPartnerQuestion',
  onboardingGoalsWelcome: 'onboardingGoalsWelcome',
  onboardingGoalSelection: 'onboardingGoalSelection',
  onboardingSaveForRetirementStep: 'onboardingSaveForRetirementStep',
  onboardingBuyAPropertyStep: 'onboardingBuyAPropertyStep',
  onboardingSaveForEducationStep: 'onboardingSaveForEducationStep',
  onboardingPayOffDebtStep: 'onboardingPayOffDebtStep',
  onboardingCustomGoalStep: 'onboardingCustomGoalStep',
  onboardingGoalSummary: 'onboardingGoalSummary',
  onboardingGoalPriority: 'onboardingGoalPriority',
  onboardingPostOnboardingFirstWin: 'onboardingPostOnboardingFirstWin',
  onboardingPostOnboardingWhatIsNext: 'onboardingPostOnboardingWhatIsNext',
  onboardingPlannerAssignmentFinalizingMatch: 'onboardingPlannerAssignmentFinalizingMatch',
  onboardingPlannerAssignmentRecommendedPlanner: 'onboardingPlannerAssignmentRecommendedPlanner',
  onboardingPlannerAssignmentSelectPlanner: 'onboardingPlannerAssignmentSelectPlanner',
  onboardingPostOnboardingScheduleFirstMeeting: 'onboardingPostOnboardingScheduleFirstMeeting',
  onboardingPostOnboardingFirstMeetingConfirmation: 'onboardingPostOnboardingFirstMeetingConfirmation',
  clientDashboard: 'clientDashboard', // this exists to handle a redirect to client dashboard from within onboarding
};

const getLayout = (headResourceType) => {
  switch (headResourceType) {
    case SURVEY_LAYOUTS.onboardingWelcome:
      return {
        layout: OnboardingWelcomeLayout,
      };
    case SURVEY_LAYOUTS.onboardingWelcomeIntro:
      return {
        metaOverrideSet: OnboardingWelcomeOverride,
        layout: WelcomeInfoLayoutDefault,
      };
    case SURVEY_LAYOUTS.onboardingWelcomeWhatToExpect:
      return {
        metaOverrideSet: OnboardingWelcomeOverride,
        layout: WelcomeInfoLayoutWithBottomImage,
      };
    case SURVEY_LAYOUTS.onboardingWelcomeHowToGetHelp:
      return {
        metaOverrideSet: OnboardingWelcomeOverride,
        layout: WelcomeInfoLayoutDefault,
      };
    case SURVEY_LAYOUTS.onboardingWelcomeThanksForSharing:
      return {
        metaOverrideSet: OnboardingWelcomeOverride,
        layout: WelcomeInfoLayoutWithBottomImage,
      };
    case SURVEY_LAYOUTS.onboardingMoneyPsychQuestionEmotionalStartingPoint:
    case SURVEY_LAYOUTS.onboardingMoneyPsychQuestionMoneyAsATool:
    case SURVEY_LAYOUTS.onboardingMoneyPsychQuestionDailyInstinct:
    case SURVEY_LAYOUTS.onboardingMoneyPsychQuestionInheritedBeliefs:
    case SURVEY_LAYOUTS.onboardingMoneyPsychQuestionSelfEfficacy:
    case SURVEY_LAYOUTS.onboardingMoneyPsychQuestionCurrentApproach:
    case SURVEY_LAYOUTS.onboardingMoneyPsychQuestionApproachAsCouple:
      return {
        metaOverrideSet: OnboardingWelcomeOverride,
        layout: OnboardingMoneyPsychQuestionLayout,
      };
    case SURVEY_LAYOUTS.onboardingEmbeddedWizard:
      return {
        layout: EmbeddedWizardLayout,
      };
    case SURVEY_LAYOUTS.onboardingPersonalInformation:
      return {
        metaOverrideSet: PersonalInformationOverride,
        layout: PersonalInformationLayout,
      };
    case SURVEY_LAYOUTS.onboardingQualitativeQuestion:
      return {
        metaOverrideSet: QualitativeQuestionOverride,
        layout: QualitativeQuestionLayout,
      };
    case SURVEY_LAYOUTS.onboardingChooseIncomeCategories:
      return {
        metaOverrideSet: ChooseIncomeCategoriesOverride,
        layout: ChooseIncomeCategoriesLayout,
      };
    case SURVEY_LAYOUTS.onboardingIncomeSectionWelcome:
      return {
        metaOverrideSet: IncomeWelcomeSectionOverride,
        layout: IncomeWelcomeLayout,
      };
    case SURVEY_LAYOUTS.onboardingAssetsAndLiabilitiesOverallChecklist:
      return {
        layout: OnboardingAssetsAndLiabilitiesOverallChecklist,
      };
    case SURVEY_LAYOUTS.OnboardingIncomeInformation:
      return {
        metaOverrideSet: IncomeInformationOverride,
        layout: IncomeInformationOnboardingLayout,
      };
    case SURVEY_LAYOUTS.OnboardingIncomeAttestationStep:
      return {
        metaOverrideSet: IncomeAttestationOverride,
        layout: IncomeAttestationLayout,
      };
    case SURVEY_LAYOUTS.DetailList:
      return {
        metaOverrideSet: DetailListOverride,
        layout: DetailListLayout,
      };
    case SURVEY_LAYOUTS.onboardingFamilyMemberDetail:
      return {
        metaOverrideSet: FamilyMemberDetailOverride,
        layout: FamilyMemberDetailLayout,
      };
    case SURVEY_LAYOUTS.onboardingCompleteMemberConciergeMeetingConfirmation:
      return {
        metaOverrideSet: CompleteMemberConciergeOverride,
        layout: CompleteMemberConciergeMeetingConfirmationLayout,
      };
    case SURVEY_LAYOUTS.onboardingCompleteMemberConciergeMeetingConfirmationMoved:
      return {
        metaOverrideSet: CompleteMemberConciergeOverride,
        layout: CompleteMemberConciergeMeetingConfirmationLayout,
      };
    case SURVEY_LAYOUTS.onboardingCompleteMemberConciergeChoosePath:
      return {
        metaOverrideSet: CompleteMemberConciergeOverride,
        layout: CompleteMemberConciergeChoosePathLayout,
      };
    case SURVEY_LAYOUTS.onboardingCompleteMemberConciergeScheduleMeeting:
      return {
        metaOverrideSet: CompleteMemberConciergeOverride,
        layout: CompleteMemberConciergeScheduleMeetingLayout,
      };
    case SURVEY_LAYOUTS.onboardingCompleted:
      return {
        layout: OnboardingCompletedLayout,
      };
    case SURVEY_LAYOUTS.onboardingSelectRecurringExpenses:
      return {
        layout: OnboardingSelectRecurringExpenses,
      };
    case SURVEY_LAYOUTS.clientDashboard:
      return {
        layout: OnboardingClientDashboardRedirect,
      };
    case SURVEY_LAYOUTS.onboardingRecurringExpenseAmounts:
      return {
        layout: OnboardingRecurringExpenses,
      };
    case SURVEY_LAYOUTS.onboardingExpenseSummary:
      return {
        layout: OnboardingExpenseSummary,
      };
    case SURVEY_LAYOUTS.onboardingRecurringExpenseFrequencies:
      return {
        layout: OnboardingRecurringExpenses,
      };
    case SURVEY_LAYOUTS.onboardingOneTimeExpenses:
      return {
        layout: OnboardingOneTimeExpenses,
      };
    case SURVEY_LAYOUTS.onboardingScheduleMeeting:
      return {
        layout: OnboardingScheduleMeetingLayout,
      };
    case SURVEY_LAYOUTS.onboardingPostOnboardingFirstWin:
      return {
        layout: OnboardingPostOnboardingFirstWin,
      };
    case SURVEY_LAYOUTS.onboardingPostOnboardingWhatIsNext:
      return {
        layout: OnboardingPostOnboardingWhatIsNext,
      };
    case SURVEY_LAYOUTS.onboardingPlannerAssignmentFinalizingMatch:
      return {
        layout: OnboardingPlannerAssignmentFinalizingMatch,
      };
    case SURVEY_LAYOUTS.onboardingPlannerAssignmentSelectPlanner:
      return {
        layout: OnboardingPlannerAssignmentSelectPlanner,
      };
    case SURVEY_LAYOUTS.onboardingPlannerAssignmentRecommendedPlanner:
      return {
        layout: OnboardingPlannerAssignmentRecommendedPlanner,
      };
    case SURVEY_LAYOUTS.onboardingPostOnboardingScheduleFirstMeeting:
      return {
        layout: OnboardingPostOnboardingScheduleFirstMeeting,
      };
    case SURVEY_LAYOUTS.onboardingPostOnboardingFirstMeetingConfirmation:
      return {
        layout: OnboardingPostOnboardingFirstMeetingConfirmation,
      };
    case SURVEY_LAYOUTS.onboardingInsight:
      return {
        layout: InsightsLayout,
      };
    case SURVEY_LAYOUTS.onboardingExpensesWelcome:
      return {
        layout: ExpensesWelcomeLayout,
      };
    case SURVEY_LAYOUTS.onboardingAssetsAndLiabilitiesWelcome:
      return {
        layout: BalanceSheetWelcomeLayout,
      };
    case SURVEY_LAYOUTS.onboardingAssetsAndLiabilitiesPartnerQuestion:
      return {
        layout: AssetsAndLiabilitiesPartnerQuestionLayout,
        metaOverrideSet: AssetsAndLiabilitiesPartnerQuestionMetaOverride,
      };
    case SURVEY_LAYOUTS.onboardingSetPassword:
      return {
        layout: AccountSetupCreatePasswordLayout,
        metaOverrideSet: AccountSetupOverride,
      };
    case SURVEY_LAYOUTS.onboardingPasswordSaved:
      return {
        layout: AccountSetupPasswordSavedLayout,
      };
    case SURVEY_LAYOUTS.onboardingShouldEnableTwoFactor:
      return {
        layout: AccountSetupTwoFactorAuthenticationLayout,
      };
    case SURVEY_LAYOUTS.onboardingSetTwoFactorPhoneNumber:
      return {
        layout: AccountSetupTwoFactorAuthenticationPhoneNumberLayout,
        metaOverrideSet: BaseOverride,
        onSubmitBefore: (res) => res.attr('phoneNumber', res.attr('phoneNumber').replace(/\D*/g, '')),
      };
    case SURVEY_LAYOUTS.onboardingShouldRememberThisDevice:
      return {
        layout: AccountSetupRememberThisDeviceLayout,
      };
    case SURVEY_LAYOUTS.onboardingVerifyTwoFactorCode:
      return {
        layout: AccountSetupTwoFactorAuthenticationVerificationLayout,
        metaOverrideSet: VerifyTwoFactorCodeOverride,
      };
    case SURVEY_LAYOUTS.onboardingTwoFactorEnabledSuccess:
      return {
        layout: AccountSetupTwoFactorEnabledSuccessLayout,
      };
    case SURVEY_LAYOUTS.onboardingRiskToleranceWelcome:
      return {
        layout: RiskToleranceWelcomeLayout,
      };
    case SURVEY_LAYOUTS.onboardingDocumentUploadWelcome:
      return {
        layout: DocumentUploadWelcomeLayout,
      };
    case SURVEY_LAYOUTS.riskToleranceQuestionThinkingAboutInvesting:
    case SURVEY_LAYOUTS.riskToleranceQuestionInvestingExperience:
    case SURVEY_LAYOUTS.riskToleranceQuestionInvestingHistory:
    case SURVEY_LAYOUTS.riskToleranceQuestionInvestingScenario:
    case SURVEY_LAYOUTS.riskToleranceQuestionWithdrawal:
    case SURVEY_LAYOUTS.riskToleranceQuestionInvestingExperienceV2:
    case SURVEY_LAYOUTS.riskToleranceQuestionInvestmentKnowledge:
    case SURVEY_LAYOUTS.riskToleranceQuestionHowIFeelAboutInvesting:
    case SURVEY_LAYOUTS.riskToleranceQuestionLongTermInvestmentPhilosophy:
    case SURVEY_LAYOUTS.riskToleranceQuestionSignificantInvestmentLossReaction:
    case SURVEY_LAYOUTS.riskToleranceQuestionBiggestFinancialConcern:
    case SURVEY_LAYOUTS.riskToleranceQuestion:
      return {
        metaOverrideSet: DefaultLayoutOverride,
        layout: QualitativeQuestionLayout,
        alwaysDisplayErrorMessage: true,
      };
    case SURVEY_LAYOUTS.riskToleranceResult:
      return {
        layout: RiskToleranceResultLayout,
      };
    case SURVEY_LAYOUTS.riskToleranceManual:
      return {
        layout: RiskToleranceManualLayout,
      };
    case SURVEY_LAYOUTS.onboardingAuthFlowSuccess:
      return {
        layout: AccountSetupSuccessLayout,
      };
    case SURVEY_LAYOUTS.onboardingIncomeSalary:
      return {
        metaOverrideSet: IncomeSalaryOverride,
        layout: IncomeSalaryLayout,
      };
    case SURVEY_LAYOUTS.OnboardingIncomeSalaryPayStubUpload:
      return {
        metaOverrideSet: IncomeSalaryPayStubUploadOverride,
        layout: IncomeSalaryPayStubUploadLayout,
      };
    case SURVEY_LAYOUTS.OnboardingIncomeSalaryPayStubDetails:
      return {
        metaOverrideSet: IncomeSalaryPayStubDetailsOverride,
        layout: IncomeSalaryPayStubDetailsLayout,
      };
    case SURVEY_LAYOUTS.onboardingGoalsWelcome:
      return {
        layout: ModuleWelcomeLayout,
      };
    case SURVEY_LAYOUTS.onboardingGoalSelection:
      return {
        layout: GoalSelectionLayout,
        metaOverrideSet: GoalSelectionOverride,
      };
    case SURVEY_LAYOUTS.onboardingAssetsAndLiabilitiesAdd:
      return {
        layout: OnboardingAssetsAndLiabilitiesAddLayout,
      };
    case SURVEY_LAYOUTS.onboardingAssetsAndLiabilitiesSummary:
      return {
        layout: OnboardingAssetsAndLiabilitiesSummaryLayout,
      };
    case SURVEY_LAYOUTS.onboardingSaveForRetirementStep:
      return {
        layout: SaveForRetirementLayout,
        metaOverrideSet: SaveForRetirementOverride,
      };
    case SURVEY_LAYOUTS.onboardingBuyAPropertyStep:
    case SURVEY_LAYOUTS.onboardingSaveForEducationStep:
    case SURVEY_LAYOUTS.onboardingCustomGoalStep:
      return {
        layout: GoalDetailLayout,
        metaOverrideSet: GoalDetailOverride,
      };
    case SURVEY_LAYOUTS.onboardingPayOffDebtStep:
      return {
        metaOverrideSet: PayOffDebtOverride,
        layout: PayOffDebtLayout,
      };
    case SURVEY_LAYOUTS.onboardingGoalSummary:
      return {
        layout: OnboardingGoalSummary,
        metaOverrideSet: GoalSummaryOverride,
      };
    case SURVEY_LAYOUTS.onboardingGoalPriority:
      return {
        layout: GoalPrioritizationLayout,
        metaOverrideSet: GoalPrioritizationOverride,
      };
    case SURVEY_LAYOUTS.onboardingIncomeBonus:
    case SURVEY_LAYOUTS.onboardingIncomeSelfEmployed:
    case SURVEY_LAYOUTS.onboardingIncomeRental:
    case SURVEY_LAYOUTS.onboardingIncomeSocialSecurity:
    case SURVEY_LAYOUTS.onboardingIncomeInvestment:
    case SURVEY_LAYOUTS.onboardingIncomeTrust:
    case SURVEY_LAYOUTS.onboardingIncomeAnnuity:
    case SURVEY_LAYOUTS.onboardingIncomePension:
    case SURVEY_LAYOUTS.onboardingIncomeOther:
      return {
        metaOverrideSet: IncomeStepOverride,
        layout: DefaultLayout,
      };
    case SURVEY_LAYOUTS.onboardingDocumentUpload:
      return {
        metaOverrideSet: DocumentUploadOverride,
        layout: DocumentUploadLayout,
      };
    default:
      return {
        metaOverrideSet: DefaultLayoutOverride,
        layout: DefaultLayout,
      };
  }
};

const SurveyStepFormLayoutPicker = ({ onboardingStepResource }) => {
  const headResourceType = onboardingStepResource?.type();
  const {
    layout,
    metaOverrideSet,
    onSubmitBefore,
    alwaysDisplayErrorMessage,
  } = getLayout(headResourceType);

  return (
    <SurveyStepForm
      key={headResourceType}
      layout={layout}
      metaOverrideSet={metaOverrideSet}
      onSubmitBefore={onSubmitBefore}
      alwaysDisplayErrorMessage={alwaysDisplayErrorMessage}
    />
  );
};

SurveyStepFormLayoutPicker.propTypes = {
  onboardingStepResource: PropTypes.object.isRequired,
};

export default SurveyStepFormLayoutPicker;
